import { inject, Injectable } from '@angular/core';
import {
  type WorkspaceDeepLinkNodeQueryQuery,
  type WorkspaceDeepLinkNodeQueryQueryVariables,
} from '@reconcept-platform/shared/types';
import { of } from 'rxjs';
import { map } from 'rxjs/operators';
import { WorkspaceGraphQLService } from '../../workspace-graphql.service';
import { WorkspaceDeepLinkNodeQuery } from './workspace-deeplink-node.queries';

export type WorkspaceDeepLinkNodeQuery_Node = WorkspaceDeepLinkNodeQueryQuery['node'];

@Injectable({
  providedIn: 'root',
})
export class WorkspaceDeeplinkNodeApi {
  private workspaceGraphQLService = inject(WorkspaceGraphQLService);

  watchObjectByNodeId(nodeId: string) {
    if (!nodeId) {
      return of(null);
    }

    return this.workspaceGraphQLService
      .watchQuery<WorkspaceDeepLinkNodeQueryQuery, WorkspaceDeepLinkNodeQueryQueryVariables>({
        query: WorkspaceDeepLinkNodeQuery,
        variables: {
          nodeId: nodeId,
        },
      })
      .pipe(map((result) => result.data.node));
  }
}
